import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all hover:border-primary-200 cursor-pointer"
    >
      <div className="relative overflow-hidden aspect-[4/3]">
        <img
          src={article.image}
          alt={article.title}
          title={`${article.title} - 今日同人库`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 object-top"
        />
        <div className="absolute top-3 left-3">
          <span className="inline-block px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
            {article.category === 'doujin-novel' && '同人小说'}
            {article.category === 'doujin-art' && '同人画作'}
            {article.category === 'doujin-music' && '同人音乐'}
            {article.category === 'doujin-goods' && '周边资讯'}
            {article.category === 'cp-recommend' && 'CP推荐'}
          </span>
        </div>
        {article.featured && (
          <div className="absolute top-3 right-3">
            <span className="inline-block px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
              精选
            </span>
          </div>
        )}
      </div>
      <div className="p-4 md:p-5">
        <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-user-line"></i>
              {article.author}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {article.readTime} 分钟
            </span>
          </div>
          <span>{article.date}</span>
        </div>
      </div>
    </Link>
  );
}